import React from "react";
import MuiDialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "../../../theme/colors";
import Button from "../button";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  root: {
    padding: "14px 27px 0 34px",
    display: "flex",
    justifyContent: "space-between",
  },
  title: {
    display: "flex",
    flex: 1,
    marginTop: 20,
    fontSize: 22,
  },
  closeIcon: {
    fontSize: 30,
    cursor: "pointer",
    color: colors.geminiGray,
  },
  closeIconContainer: {},
});

export interface IDialogTitleProps {
  children: string;
  onClose: () => void;
  isCloseButtonDisabled?: boolean;
  showCloseButton?: boolean;
}

export function DialogTitle(props: IDialogTitleProps) {
  const { classes } = useStyles();

  let showCloseButton = typeof props.showCloseButton === "boolean"
      ? props.showCloseButton
      : true;

  return (
    <MuiDialogTitle classes={{ root: classes.root }}>
      <div
        className={classes.title}
        data-testid="alert-title-text"
      >
        {props.children}
      </div>

        {showCloseButton &&
          <div
            className={classes.closeIconContainer}
            data-testid="alert-close"
          >
              <Button
                  testId="btn--close"
                  disabled={props.isCloseButtonDisabled}
              >
                <CloseIcon
                  classes={{ root: classes.closeIcon }}
                  onClick={props.onClose}
                />
              </Button>
          </div>
        }

    </MuiDialogTitle>
  );
}
